export const DEFAULT_CONFIG_ID_LOCAL_STORAGE_KEY = 'ls:smith-default-config-id';

export const INJECT_ALL_ATTACHMENTS_DELIMETER =
  '__langsmith_playground_inject_all_attachments__';
export const INJECT_ALL_ATTACHMENTS_NAME = 'All Attachments';
export const PLAYGROUND_RESERVED_NAMES = {
  [INJECT_ALL_ATTACHMENTS_DELIMETER]: INJECT_ALL_ATTACHMENTS_NAME,
};
